<template>
    <div class="users-style-new">
        
        <ul class="dropdown-menu-new">
            <li class="nav-item" v-for='company in companies'>
                <div v-if="company.company_id == company_id" class="nav-link select-company-container active"  @click="selectCompany(company.company_id , company.employee_id)">
                    <div class="company-logo-container">
                        
                        <img :src="$api_url+'/images/company/'+company.company_logo" class="img-fluid" :alt="company.company_name">
                    </div>

                    <b-form-checkbox
                        v-model="selected"
                        :key="company.company_id"
                        :value="company.company_id"
                        name="flavour-3a"
                    >
                    </b-form-checkbox>
                    
                </div>
                <div v-else class="nav-link select-company-container"  @click="selectCompany(company.company_id , company.employee_id)">
                    <div class="company-logo-container">
                        <img :src="$api_url+'/images/company/'+company.company_logo" class="img-fluid" :alt="company.company_name">
                    </div>
                    <b-form-checkbox
                    v-model="selected"
                    :key="company.company_id"
                    :value="company.company_id"
                    name="flavour-3a"
                >
                </b-form-checkbox>
                    
                </div>
                
            </li>
        </ul>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        props: [],
        data(){            
            
            return {               
                
                companies: [],

                company_logo: null,                
                company_name:null,
                company_id:null,
                selected:null,
                
            }
        },
        methods:{
            getEmployeeCompanies: function()
            {
                axios.get(this.$api_url+'/front/employee/company/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.companies = response.data;
                    this.getCurrentCompany();
                }.bind(this));
            },
            getCurrentCompany: function()
            {
                axios.get(this.$api_url+'/front/company/publicinfo' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){         
                    //console.log(response.data);           
                    this.company_logo = response.data.logo;
                    this.company_name = response.data.name;
                    this.company_id = response.data.id;
                    this.selected = this.company_id;
                }.bind(this));
            },
            selectCompany:function(x , y)
            {               
                let formData = new FormData();
                formData.append('company_id', x);
                formData.append('employee_id', y);
                
                axios.post(this.$api_url+'/front/employee/setcompany', formData)
                                .then(function (response) 
                                {         
                                    this.$cookies.set("last_clicked_component" ,"employee-dashboard");                                                           
                                    //window.location.href = this.$api_url+'/front/company/dashboard';
                                    window.location.reload(true);
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            

        },
        created: function(){
            this.getEmployeeCompanies();
        }
    }
</script>
<style scoped>.company-logo-container { font-size: 12px;}</style>